import React from "react";
import "../../components/DepartmentList/DepartmentList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useState } from "react";

const DepartmentList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile ,
  setOpenAddProfile 
}) => {
  
  // const [selectedUserId, setSelectedUserId] = useState(null);

  function HandleChange(param) {
    
    GetId(param);
  }

  return (
    <div className="container-fluid">
      <div className="departmentList">
        <table>
          <tr className="departmentListHeading">
            <th>S No.</th>
            <th>Department ID</th>
            <th>Department</th>

            <th>Action</th>
          </tr>
          {userDetailResponse !== null ? (
            userDetailResponse.map((user, index) => (
              <tr key={user.dept_id}>
                <td>{index + 1}</td>
                <td>{user.dept_id}</td>
                <td>{user.department}</td>

                <td>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}
                    onClick={() => {
                      setOpenProfile(!openProfile);
                      HandleChange(user.dept_id); 
                      setOpenAddProfile(false);                  
                    }}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}
        </table>
      </div>
    </div>
  );
};

export default DepartmentList;
